import axios from "axios";
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { useNavigate, useSearchParams } from "react-router-dom";

const ShopifyApiKey = ({ sessionId, redirect }) => {
  // const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // console.log("redirectUrl searchParams", redirect);
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [success, setSuccess] = useState(false);

  // console.log("redirectUrl", redirectUrl);
  // useEffect(() => {
  //   const encodedRedirectUrl = redirect;
  //   console.log("encodedRedirectUrl redirect", encodedRedirectUrl);

  //   if (encodedRedirectUrl) {
  //     setRedirectUrl(decodeURIComponent(encodedRedirectUrl));
  //   }
  // }, []);

  useEffect(() => {
    setRedirectUrl(redirect);
  }, [sessionId]);

  const handleTrackClick = () => {
    if (!apiKey) {
      setError("Please enter your API key");
      setSuccess(false);
      return;
    }
    setError(null);
    fetchData(apiKey);
    setSuccess(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleTrackClick();
    }
  };

  const handleInputChange = (e) => {
    setApiKey(e.target.value.trim());
  };

  const fetchData = async (key) => {
    try {
      const response = await axios.get(
        `https://b2b.truxcargo.com/api/shopify/authenticate/${key}`
      );

      // console.log("response authenticate", response.data?.status);

      if (response.data?.status === true) {
        authSession(key);
      } else if (
        response.data?.status === false &&
        response.data?.message === "Incorrect KEY"
      ) {
        setError("Incorrect KEY");
        setSuccess(false);
      } else {
        setError("Invalid API Key");
        setSuccess(false);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setError(error?.message);
      setSuccess(false);
    }
  };

  const postData = async (keyId) => {
    try {
      const url = "https://b2b.truxcargo.com/api/shopify/auth";
      const body = {
        sid: sessionId,
        key: keyId,
      };
      // console.log("body", body);

      const response = await axios.post(url, body);
      // console.log("response shopify/auth", response);

      if (response.data?.status === true) {
        setSuccess(true); // ✅ show success popup
        setTimeout(() => setSuccess(false), 3000); // hide after 3 secondss
        if (redirectUrl) {
          const formattedUrl = redirectUrl.startsWith("http")
            ? redirectUrl
            : `https://${redirectUrl}`;
          // console.log("Redirecting to:", formattedUrl);
          window.location.href = formattedUrl;
        }

        // setError("Successfully Added");
      } else if (
        response.data?.status === false &&
        response.data?.message === "Already exists Session Id"
      ) {
        // console.log("Already exists Session Id");
        setError("Already exists Session Id");
        setSuccess(false);
      }
    } catch (error) {
      console.error("Error posting data", error);
      setError(error?.message);
      setSuccess(false);
    }
  };

  const authSession = async (keyId) => {
    try {
      const url =
        "https://middleware.truxcargo.com/truxcargo/auth/session/apiKey";
      const body = {
        sessionId: sessionId,
        apiKey: keyId,
      };
      // console.log("body session/apiKey", body);

      const response = await axios.post(url, body);
      // console.log("response auth/session/apiKey 121", response);

      if (response.data?.Status === "OK") {
        postData(keyId);
      } else if (response.data?.status) {
        // console.log(response);
      }
    } catch (error) {
      console.error("Error posting data", error?.message);
      setError(error?.message);
      setSuccess(false);
    }
  };

  return (
    <section className="my-4">
      <div className="track-shipments">
        <Form className="d-flex">
          <div className="w-100">
            <div className="tracking_shipment">
              <input
                type="text"
                placeholder="Please enter your API key"
                value={apiKey}
                className="form-control w-100"
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                required
              />
              <button
                type="button"
                className="button-34"
                onClick={handleTrackClick}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </div>
      {error && (
        <div
          style={{
            backgroundColor: "white",
            padding: "5px",
            borderRadius: "5px",
            marginTop: "10px",
            width: "30%",
          }}
        >
          <p
            className="error-message"
            style={{ marginLeft: "2%", marginTop: "1%", color: "#f50a0a" }}
          >
            {error}
          </p>
        </div>
      )}
      {success && (
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "5px",
            marginTop: "10px",
            width: "30%",
          }}
        >
          <p
            className="success-message"
            style={{
              marginLeft: "2%",
              marginTop: "5%",
              fontWeight: "bold",
              color: "#0a8f50",
            }}
          >
            Successfully Added!
          </p>
        </div>
      )}
    </section>
  );
};

export default ShopifyApiKey;
